<template>
    <div>
        <span>{{ message }}</span>
    </div>
</template>

<script>
export default {
    name: "RelationUpdated",
    props: {
        activity: {
            type: Object,
            required: true
        }
    },
    computed: {
        message() {
            return this.$t('notification.relationUpdated', {
                actor: this.$_.get(this.activity, 'actorUser.name'),
                relationName: this.$_.get(this.activity, 'payload.displayName')
            });
        }
    }
};
</script>


